import UAI from "./UAI"
import log from "loglevel"
import Utils from "./sgc/Utils"
import tutoriales from "./Tutoriales/Tutoriales"

/**
 * Clase que representa toda la información de un usuario, sus cohortes, vistas
 * atributos y roles.
 */
class Usuario {
  hash = null
  esadministrador = false
  username = null
  roles = []
  unidadesventa = {}
  facultades = {}
  coordinadorasadmision = {}
  coordinadorasprogramas = {}
  tienePermisoEdicionPostula = false
  tienePermisoEntrevistas = false
  tienePermisoImpersonar = false
  views = []
  externals = []
  defaultView = null
  periodo = null
  atributos = {}
  defaultTabs = {}
  cohortes = {}

  constructor(
    _usuario,
    _periodo,
    callbackprogress,
    callbacksuccess,
    callbackerror
  ) {
    if (_usuario === undefined) {
      throw new Error("Usuario no definido!")
    }
    log.info("Cargando usuario " + _usuario)
    callbackprogress("Cargando cohortes " + _usuario + " " + _periodo, 50)
    UAI.obtieneCohortesUsuario(
      _usuario,
      _periodo,
      UAI.atributosMinimos,
      false,
      false,
      (num) => {
        callbackprogress(
          "Cargando cohortes " + _usuario + " " + _periodo,
          50 + num * 20
        )
      },
      (result) => {
        let usuario = this.obtieneUsuario(result, _periodo)
        if (!usuario) {
          callbackerror("Usuario no encontrado en Postula")
          return null
        }
        log.info(usuario.cohortes.length + " cohortes obtenidos")
        if (usuario.porCargar.length > 0) {
          log.info(
            "Quedaron " +
              usuario.porCargar.length +
              " cohortes pendientes que no venían en el primer request. Obteniendo..."
          )
          const request = async () => {
            await UAI.obtieneDetallesCohortesPorId(
              usuario.porCargar,
              (detalles) => {
                UAI.agregarDetallesCohorteUsuario(usuario, detalles, result)
                delete usuario.porCargar
                try {
                  UAI.agregarCohortesCache(
                    result,
                    (r) => {
                      this.obtieneUsuarioSuccess(
                        result,
                        _periodo,
                        callbackprogress,
                        callbacksuccess,
                        callbackerror
                      )
                    },
                    (error) => {
                      log.error(error)
                      throw new Error(error)
                    }
                  )
                } catch (e) {
                  log.error(e)
                  callbackerror(e)
                }
              },
              (error) => {
                log.error(error)
                callbackerror(error)
              },
              UAI.atributosMinimos
            )
          }
          callbackprogress(
            "Procesando datos de cohortes " + _usuario + " " + _periodo,
            90
          )
          log.info("Cargando datos de cohortes benchmark")
          request()
        } else {
          callbackprogress(
            "Procesando datos de cohortes " + _usuario + " " + _periodo,
            90
          )
          try {
            UAI.agregarCohortesCache(
              result,
              (r) => {
                this.obtieneUsuarioSuccess(
                  result,
                  _periodo,
                  callbackprogress,
                  callbacksuccess,
                  callbackerror
                )
              },
              (e) => {
                throw e
              }
            )
          } catch (e) {
            log.error(e)
            callbackerror(e)
          }
        }
      },
      (error) => {
        this.obtieneUsuarioError(error)
        callbackerror(error)
      }
    )
  }

  /**
   *
   * @param {*} result
   * @param {*} _periodo
   * @param {*} callbackprogress
   * @param {*} callbacksuccess
   * @param {*} callbackerror
   * @returns
   */
  obtieneUsuarioSuccess(
    result,
    _periodo,
    callbackprogress,
    callbacksuccess,
    callbackerror
  ) {
    let usuario = this.obtieneUsuario(result, _periodo)
    if (!usuario) {
      callbackerror("Usuario no encontrado en Postula")
      return null
    }
    usuario = this.obtieneConfiguracionUsuario(usuario)
    if (!usuario) {
      log.error(result)
      callbackerror(
        "OOPS! No encontramos la información de tu usuario :-O por favor avisa al administrador, debe ser solamente un glitch en la matrix."
      )
      return null
    }
    callbackprogress(
      "Procesando información de cohortes " + usuario.username,
      99
    )

    if (usuario.porCargar) {
      if (usuario.porCargar.length > 0) {
        log.warn(
          "ERROR! Quedaron cohortes por cargar cuya información no fue obtenida"
        )
        log.warn(usuario.porCargar)
      }
      delete usuario.porCargar
    }

    // Cálculo de facultades y unidades de venta cuando el usuario solo tiene un listado de cohortes
    usuario.facultades = {}
    usuario.unidadesventa = {}
    let unidadesventa = JSON.parse(
      JSON.stringify(UAI.configuracion.unidadesventa)
    )

    let cohortesClean = this.agregarCohortes(
      usuario.cohortes,
      _periodo,
      usuario,
      unidadesventa
    )
    log.debug("Tenemos " + Object.values(cohortesClean).length + " cohortes!")

    delete usuario.cohortes
    usuario.cohortes = cohortesClean
    usuario.cohortesBenchmarkSinInfo = []

    // Agregamos los ciclos de vida de cohortes
    usuario.ciclovida = usuario.ciclovida || {}
    Object.values(UAI.EtapasCicloVidaCohortes).forEach((etapa) => {
      usuario.ciclovida[etapa.key] = usuario.ciclovida[etapa.key] || {
        key: etapa.key,
        nombre: etapa.nombre,
        cohortes: [],
      }
    })

    // Link a cohorte benchmark si es que tiene y no es borrador
    Object.values(usuario.cohortes).forEach((cohorte) => {
      if (
        cohorte.programaid_anterior > 0 &&
        cohorte.id > 0 &&
        cohorte.programaid_anterior !== cohorte.id &&
        cohorte.programaid_anterior < cohorte.id
      ) {
        if (usuario.cohortes[cohorte.programaid_anterior]) {
          cohorte.benchmarkinfo = usuario.cohortes[cohorte.programaid_anterior]
          usuario.cohortes[cohorte.programaid_anterior].esBenchmark = true
          usuario.cohortes[cohorte.programaid_anterior].esBenchmarkId =
            cohorte.id
        } else if (cohorte["año_inicio"] >= _periodo) {
          usuario.cohortesBenchmarkSinInfo.push(
            cohorte.programaid_anterior +
              " benchmark de " +
              cohorte.id +
              " - " +
              cohorte.nombre
          )
        }
      }
      // Agregamos las coordinadoras de admisión al usuario
      let coordinadora = cohorte.usuario_coordinador_admision
      let año = cohorte["año_inicio"]
      usuario.coordinadorasadmision = usuario.coordinadorasadmision || {}
      usuario.coordinadorasadmision[coordinadora] = usuario
        .coordinadorasadmision[coordinadora] || {
        key: coordinadora,
        nombre: cohorte.NombreCoordinadorAdmision,
        cohortes: {},
      }
      usuario.coordinadorasadmision[coordinadora].cohortes[año] =
        usuario.coordinadorasadmision[coordinadora].cohortes[año] || []
      usuario.coordinadorasadmision[coordinadora].cohortes[año].push(cohorte.id)
      // Agregamos las coordinadoras de programa al usuario
      let coordinadoraAcademica = cohorte.coordinador_academico
      usuario.coordinadorasprogramas = usuario.coordinadorasprogramas || {}
      usuario.coordinadorasprogramas[coordinadoraAcademica] = usuario
        .coordinadorasprogramas[coordinadoraAcademica] || {
        key: coordinadoraAcademica,
        nombre: cohorte.NombreCoordinadorAcademico,
        cohortes: {},
      }
      usuario.coordinadorasprogramas[coordinadoraAcademica].cohortes[año] =
        usuario.coordinadorasprogramas[coordinadoraAcademica].cohortes[año] ||
        []
      usuario.coordinadorasprogramas[coordinadoraAcademica].cohortes[año].push(
        cohorte.id
      )
      cohorte.etapaCicloVida = cohorte.etapaCicloVida || []
      // Agregamos los ciclos de vida de cohortes
      Object.values(UAI.EtapasCicloVidaCohortes).forEach((etapa) => {
        usuario.ciclovida[etapa.key].cohortes =
          usuario.ciclovida[etapa.key].cohortes || []
        if (etapa.filtro && etapa.filtro(cohorte, _periodo)) {
          usuario.ciclovida[etapa.key].cohortes.push(cohorte.id)
          cohorte.etapaCicloVida.push(etapa.key)
        }
      })
    })

    if (usuario.cohortesBenchmarkSinInfo.length > 0) {
      UAI.notificacionUsuario(
        usuario,
        "Hay " +
          usuario.cohortesBenchmarkSinInfo.length +
          " cohortes cuyos benchmark no han sido cargados",
        usuario.cohortesBenchmarkSinInfo
      )
    }

    if (Object.keys(usuario.unidadesventa).length === 0) {
      log.debug(usuario)
      throw new Error("Usuario sin unidades de venta")
    }

    // Limpieza de listado de facultades dentro de cada unidad de admisión
    for (let idu in usuario.unidadesventa) {
      let uv = usuario.unidadesventa[idu]
      if (!uv.facultades) {
        log.debug("Borrando unidad venta " + idu)
        delete usuario.unidadesventa[idu]
        continue
      }
      // Limpieza de facultades vacías en unidades de venta
      let _facultades = []
      Object.keys(uv.facultades).forEach((idfc) => {
        let fac = uv.facultades[idfc]
        if (fac && fac.length === 0) {
          log.debug(
            "Borrando facultades cohortes " + idfc + " de unidad venta " + idu
          )
          delete uv.facultades[idfc]
        } else {
          _facultades.push(idfc)
        }
      })
      uv.facultadesArray = _facultades
      uv.totalesborradores = uv.totalesborradores || {}
      uv.totalescohortes = uv.totalescohortes || {}
    }
    // Orden de las unidades de venta de acuerdo a campo "orden"
    let _unidadesventaordenadas = {}
    Object.values(usuario.unidadesventa)
      .sort(function (a, b) {
        return a.orden - b.orden
      })
      .forEach((element) => {
        _unidadesventaordenadas[element.key] = element
      })
    delete usuario.unidadesventa
    usuario.unidadesventa = _unidadesventaordenadas

    // Aumentamos objetos facultades con puntero a sus cohortes ordenados por UV
    Object.values(usuario.facultades).forEach((_facultad) => {
      _facultad.unidadesventa = {}
      Object.keys(usuario.unidadesventa).forEach((_uvKey) => {
        let _cohortes =
          usuario.unidadesventa[_uvKey].facultades[_facultad.key] || {}
        if (Object.keys(_cohortes).length !== 0) {
          _facultad.unidadesventa[_uvKey] = {}
          Object.assign(_facultad.unidadesventa[_uvKey], _cohortes)
        }
      })
    })

    // TODO: Fix para nombre de roles
    if (
      usuario.roles.indexOf("Director Ejecutivo") >= 0 ||
      usuario.roles.indexOf("Director Ejecutivo Postgrado") >= 0
    ) {
      usuario.roles.push("Director Ejecutivo Postgrados")
    }

    usuario.tienePermisoEdicionPostula =
      usuario.roles.indexOf("Administrador") >= 0 ||
      usuario.roles.indexOf("Coordinadora Admision") >= 0 ||
      usuario.roles.indexOf("Director Ejecutivo Postgrados") >= 0 ||
      usuario.roles.indexOf("Director de Ventas") >= 0

    usuario.tienePermisoEntrevistas =
      usuario.roles.indexOf("Administrador") >= 0 ||
      usuario.roles.indexOf("Coordinadora Admision") >= 0 ||
      usuario.roles.indexOf("Director de Ventas") >= 0 ||
      usuario.roles.indexOf("Director de Programa") >= 0 ||
      usuario.roles.indexOf("Director Ejecutivo Postgrados") >= 0

    usuario.tienePermisoImpersonar = UAI.permisosImpersonar[usuario.username]

    // Calculamos la vista por defecto de este usuario
    let defaultView = UAI.vistas["info-general"]

    // Si tiene algún rol asignado, buscamos la vista por defecto del primer rol en la lista y lo dejamos así
    usuario.roles.forEach((rol) => {
      if (UAI.vistas[UAI.vistasPorDefecto[rol]]) {
        defaultView = UAI.vistas[UAI.vistasPorDefecto[rol]]
        return
      }
    })

    // Cálculo de todas las vistas
    let views = []
    for (let idx in UAI.vistas) {
      let view = UAI.vistas[idx]
      if (idx === "postulacion") {
        log.debug(view)
      }
      view.key = idx
      if (tutoriales[idx]) {
        view.tour = idx
      } else if (!view.external) {
        view.tour = "vista"
      }
      if (view.roles) {
        let intersection = usuario.roles.filter((element) =>
          view.roles.includes(element)
        )
        if (
          intersection.length > 0 ||
          usuario.roles.indexOf("Administrador") >= 0 ||
          view.roles[0] === "*"
        ) {
          views.push(view)
        }
      } else {
        views.push(view)
      }
      if (view.usuarios && view.usuarios.includes(usuario.username)) {
        if (!views.includes(view)) {
          views.push(view)
        }
      }
    }

    // Calculamos si cada atributo del usuario es editable considerando sus roles
    let atributosSinInformacion = []
    let atributosJsonSchemaInvalidos = []
    Object.values(UAI.configuracion.atributos).forEach((atributo) => {
      let esadministrador = usuario.roles.indexOf("Administrador") >= 0
      let editable = false
      let visible = esadministrador
      let editablePorPaso = {}
      let visiblePorPaso = {}
      if (atributo.Codigo === "fecha_inicio") {
        log.debug(atributo)
      }
      if (
        UAI.displayatributos[atributo.Codigo] &&
        UAI.displayatributos[atributo.Codigo].tipo !== undefined
      ) {
        atributo.Tipo = UAI.displayatributos[atributo.Codigo].tipo
      }
      if (!atributo.Permisos) {
        atributosSinInformacion.push(atributo)
      } else {
        atributo.Permisos.forEach((permiso) => {
          editable =
            editable ||
            (usuario.roles.indexOf(permiso.Perfil) >= 0 &&
              permiso.Permiso === "Editable") ||
            esadministrador
          visible =
            visible ||
            (usuario.roles.indexOf(permiso.Perfil) >= 0 &&
              (permiso.Permiso === "Visible" || permiso.Permiso === "Editable"))

          editablePorPaso[permiso.PasoId] =
            editablePorPaso[permiso.PasoId] ||
            (usuario.roles.indexOf(permiso.Perfil) >= 0 &&
              permiso.Permiso === "Editable")
          visiblePorPaso[permiso.PasoId] =
            visiblePorPaso[permiso.PasoId] ||
            (usuario.roles.indexOf(permiso.Perfil) >= 0 &&
              (permiso.Permiso === "Visible" || permiso.Permiso === "Editable"))
        })
      }
      if (
        UAI.displayatributos[atributo.Codigo] &&
        UAI.displayatributos[atributo.Codigo].editable !== undefined
      ) {
        editable = UAI.displayatributos[atributo.Codigo].editable
      }
      editable =
        editable &&
        (atributo.Tipo === "Selector" ||
          atributo.Tipo === "SelectorMultiple" ||
          atributo.Tipo === "Numerico" ||
          atributo.Tipo === "Texto" ||
          atributo.Tipo === "TextoGrande" ||
          atributo.Tipo === "Booleano" ||
          atributo.Tipo === "Fecha" ||
          (atributo.Tipo === "Json" && atributo.Schema))
      atributo.editable = editable
      atributo.visible = visible
      atributo.editablePorPaso = editablePorPaso
      atributo.visiblePorPaso = visiblePorPaso
      // Parseando Schema de atributo Json
      if (atributo.Tipo === "Json" && atributo.Schema) {
        let newSchema = null
        try {
          newSchema = JSON.parse(atributo.Schema)
        } catch (error) {
          log.debug(atributo.Schema)
          log.error(error)
          atributosJsonSchemaInvalidos.push(atributo)
          newSchema = null
        }
        atributo.Schema = newSchema
      }
      // Creando funciones de validación
      if (!atributo.validar) {
        if (atributo.Tipo === "Texto" || atributo.Tipo === "Selector") {
          atributo.validar = (cohorte) => {
            return (
              cohorte[atributo.key] &&
              cohorte[atributo.key] !== "" &&
              cohorte[atributo.key].toString().trim().length >= 1
            )
          }
        } else if (atributo.Tipo === "Fecha") {
          atributo.validar = (cohorte) => {
            return (
              cohorte[atributo.key] &&
              cohorte[atributo.key] !== "" &&
              !isNaN(new Date(Date.parse(cohorte[atributo.key].toString())))
            )
          }
        }
      } else {
        log.debug("Atributo ya tiene función validar!")
        log.debug(atributo)
      }
    })

    if (atributosSinInformacion.length > 0) {
      UAI.notificacionUsuario(
        usuario,
        "Existen " +
          atributosSinInformacion.length +
          " atributos sin información de permisos!",
        atributosSinInformacion
      )
    }

    if (atributosJsonSchemaInvalidos.length > 0) {
      UAI.notificacionUsuario(
        usuario,
        "Existen " +
          atributosJsonSchemaInvalidos.length +
          " atributos JSON con schema inválido!",
        atributosJsonSchemaInvalidos
      )
    }

    let tabTypeDefault =
      usuario.roles.indexOf("Director Ejecutivo Postgrados") < 0 ||
      usuario.roles.indexOf("Administrador") >= 0
        ? UAI.tabTypes.UNIDADESVENTA_FACULTADES
        : UAI.tabTypes.FACULTADES_UNIDADESVENTA
    let resumenDefault =
      defaultView.key === "reportematriculas" ||
      window.location.pathname.slice(0, 18) === "/reportematriculas"
    let [today, ,] = UAI.obtieneFechasReporte(new Date(), _periodo)
    let userparts = usuario.username.split(".")
    let usernameshort = "NN"
    if (userparts.length > 0) {
      usernameshort = userparts[0].slice(0, 1)
      if (userparts.length > 1) {
        usernameshort += userparts[1].slice(0, 1)
      }
      usernameshort = usernameshort.toLocaleUpperCase()
    }

    this.fechaReporte = today
    this.tabType = tabTypeDefault
    this.coordinadorasadmision = usuario.coordinadorasadmision
    this.coordinadorasprogramas = usuario.coordinadorasprogramas
    this.ciclovida = usuario.ciclovida
    this.atributos = UAI.configuracion.atributos
    this.cohortes = usuario.cohortes
    this.notificaciones = this.notificaciones
      ? this.notificaciones.concat(usuario.notificaciones)
      : usuario.notificaciones
    this.programas = usuario.programas
    this.defaultView = defaultView
    this.esadministrador = usuario.esadministrador
    this.facultades = usuario.facultades
    this.periodo = _periodo
    this.roles = usuario.roles
    this.tienePermisoEdicionPostula = usuario.tienePermisoEdicionPostula
    this.tienePermisoEntrevistas = usuario.tienePermisoEntrevistas
    this.tienePermisoImpersonar = usuario.tienePermisoImpersonar
    this.unidadesventa = usuario.unidadesventa
    this.username = usuario.username
    this.usernameshort = usernameshort
    this.views = views
    this.defaultTabs = UAI.obtieneTabDefaults(
      this,
      resumenDefault,
      this.tabType
    )
    this.hash = Math.random()
    this.atributosCargados = usuario.atributosCargados

    log.info("Usuario OK")
    log.debug(JSON.parse(JSON.stringify(this)))
    UAI.logLineaDelimitadorGruesa()
    callbackprogress("Usuario " + usuario.username + " cargado", 100)
    callbacksuccess()
  }

  /**
   * Procesa atributos crudos (JSON.parse) y convierte en objetos JSON para
   * un conjunto de atributos y opcionalmente un conjunto de cohortes (todos si no se especifica)
   * @param {Array} atributosJSON listado de atributos que serán procesados como JSON
   * @param {Array} _cohortes listado de cohortes del usuario
   */
  procesaAtributosJSONSimple(atributosJSON, cohortes = null) {
    // Procesamiento de JSON metas mensuales
    let cohortesConDatosInvalidosJSON = {}
    let _cohortes = cohortes ? cohortes : Object.values(this.cohortes)
    atributosJSON.forEach((a) => {
      cohortesConDatosInvalidosJSON[a] = cohortesConDatosInvalidosJSON[a] || []
      _cohortes
        .filter((c) => {
          return c[a] && c[a] !== "" && !c["parsed_" + a]
        })
        .forEach((_coh) => {
          try {
            _coh["parsed_" + a] = JSON.parse(_coh[a])
          } catch (e) {
            cohortesConDatosInvalidosJSON[a].push(_coh.id + " " + _coh.nombre)
          }
        })
      if (cohortesConDatosInvalidosJSON[a].length > 0) {
        UAI.notificacionUsuario(
          this,
          "Hay " +
            cohortesConDatosInvalidosJSON[a].length +
            " cohortes con datos JSON inválidos de " +
            a,
          cohortesConDatosInvalidosJSON[a]
        )
      }
    })
  }

  /**
   * Procesa atributos crudos (JSON.parse) y convierte en objetos JSON para
   * un conjunto de atributos y opcionalmente un conjunto de cohortes (todos si no se especifica)
   * @param {Array} atributosJSON listado de atributos que serán procesados como JSON
   * @param {Array} _cohortes listado de cohortes del usuario
   */
  procesaAtributosJSON(atributosJSON, cohortes = null) {
    // Procesamiento de JSON metas mensuales
    let cohortesConDatosInvalidosJSON = {}
    let _cohortes = cohortes ? cohortes : Object.values(this.cohortes)
    atributosJSON.forEach((a) => {
      cohortesConDatosInvalidosJSON[a] = cohortesConDatosInvalidosJSON[a] || []
      _cohortes
        .filter((c) => {
          return c[a] && c[a] !== "" && !c["parsed_" + a]
        })
        .forEach((_coh) => {
          try {
            _coh["parsed_" + a] = JSON.parse(_coh[a])
          } catch (e) {
            cohortesConDatosInvalidosJSON[a].push(_coh.id + " " + _coh.nombre)
          }
        })
      if (cohortesConDatosInvalidosJSON[a].length > 0) {
        log.debug(
          "Hay " +
            cohortesConDatosInvalidosJSON[a].length +
            " cohortes con datos JSON inválidos de " +
            a
        )
        log.debug(cohortesConDatosInvalidosJSON[a])
      }
    })

    // Procesamiento de JSON encuestas para cada cohorte
    let cohortesConDatosInvalidosEncuestas = []
    _cohortes.forEach((_coh) => {
      try {
        _coh["parsed_google_analytics_data"] = JSON.parse(
          _coh["google_analytics_data"]
        )
      } catch (e) {
        _coh["parsed_google_analytics_data"] = null
      }
      try {
        _coh["parsed_datos_salesforce"] = JSON.parse(_coh["datos_salesforce"])
      } catch (e) {
        _coh["parsed_datos_salesforce"] = null
      }
      Object.keys(UAI.encuestas).forEach((encuesta) => {
        if (!UAI.cohorteSinMedicionEncuesta(_coh, encuesta)) {
          try {
            _coh["parsed_" + encuesta] = JSON.parse(_coh[encuesta])
          } catch (error) {
            _coh["parsed_" + encuesta] = null
            _coh["errores_encuestas"] = _coh["errores_encuestas"] || []
            _coh["errores_encuestas"].push(encuesta)
          }
        }
      })
      // Si el cohorte tiene errores en la encuesta, agregamos a reporte
      if (_coh["errores_encuestas"] && _coh["errores_encuestas"].length > 0) {
        cohortesConDatosInvalidosEncuestas.push(_coh)
      }
      // Si el cohorte tiene padre, buscar al padre
      if (_coh["cohorte_padre_indicadores"] > 0) {
        let idx = parseInt(_coh["cohorte_padre_indicadores"])
        if (this.cohortes[idx]) {
          this.cohortes[idx].hijos_indicadores =
            this.cohortes[idx].hijos_indicadores || []
          if (_coh.id === null) {
            log.debug(_coh)
            throw new Error("Programa sin ID")
          }
          this.cohortes[idx].hijos_indicadores.push(_coh.id)
        } else {
          log.debug(
            "Cohorte " +
              _coh.id +
              " " +
              _coh.nombre +
              " es hijo de " +
              idx +
              " pero no tenemos ese cohorte en el listado de cohortes"
          )
        }
      }
      _coh = Utils.calculaIndicadoresCohortes(_coh)
    })

    _cohortes
      .filter((c) => {
        return (
          c.hijos_indicadores &&
          Array.isArray(c.hijos_indicadores) &&
          c.hijos_indicadores.length > 0
        )
      })
      .forEach((_coh) => {
        Object.keys(UAI.encuestas)
          .filter((k) => {
            return k !== "encuesta_docente"
          })
          .forEach((encuesta) => {
            _coh[
              "parsed_" + encuesta + "_hijos"
            ] = _coh.hijos_indicadores.reduce((prev, current) => {
              return UAI.sumaEncuestas(prev, current["parsed_" + encuesta])
            }, undefined)
          })
      })

    // Reportar cohortes con datos erróneos de encuestas
    if (cohortesConDatosInvalidosEncuestas.length > 0) {
      log.debug(
        "Existen " +
          cohortesConDatosInvalidosEncuestas.length +
          " cohortes con datos erróneos de encuestas!"
      )
    }
  }

  /**
   *
   * @param {*} cohortes
   * @param {*} periodo
   * @param {*} usuario
   * @param {*} unidadesventa
   * @returns
   */
  agregarCohortes(cohortes, periodo, usuario, unidadesventa) {
    let cohortesClean = {}
    let cohortesSinUV = []
    let cohortesInvalidos = {}
    cohortes.forEach((cohorig) => {
      if (!cohorig.CohortesSalida) {
        log.debug("Cohorte sin información de salida")
        log.debug(cohorig)
        throw new Error("Cohorte sin información de salida")
      }
      let coh = null
      try {
        coh = this.agregarCohorte(cohorig, periodo, usuario, unidadesventa)
      } catch (e) {
        let _coh = UAI.completaAtributosCohorte(cohorig, periodo)
        cohortesInvalidos[_coh.id] = cohorig
        return
      }

      if (!coh.unidadesventa || coh.unidadesventa.length === 0) {
        cohortesSinUV.push(coh.id + " - " + coh.nombre)
      }
      cohortesClean[coh.id] = coh
    })

    if (Object.values(cohortesSinUV).length > 0) {
      UAI.notificacionUsuario(
        usuario,
        "Hay " +
          Object.values(cohortesSinUV).length +
          " cohortes sin Unidad de Admisión",
        cohortesSinUV
      )
    }
    if (Object.values(cohortesInvalidos).length > 0) {
      UAI.notificacionUsuario(
        usuario,
        "Hay " +
          Object.values(cohortesInvalidos).length +
          " cohortes inválidos",
        cohortesInvalidos
      )
    }
    return cohortesClean
  }

  agregarCohorte(cohorte, periodo, usuario, unidadesventa) {
    if (
      !cohorte ||
      !cohorte.CohortesSalida ||
      !periodo ||
      !usuario ||
      !unidadesventa
    ) {
      throw new Error("Parámetros inválidos para agregar cohorte")
    }
    // Crea varios atributos en formato JS
    let coh = UAI.completaAtributosCohorte(cohorte, periodo)
    // Inicializamos la facultad de este cohorte
    let facultad = UAI.obtieneFacultadPorId(coh.facultad_id)
    usuario.facultades[facultad.key] =
      usuario.facultades[facultad.key] || facultad
    // Verificamos datos mínimos para funcionar
    this.verificaCohorte(coh, facultad)
    // Inicializamos el listado de programas TODO: Reduce luego del listado completo
    usuario.programas = usuario.programas || []

    if (
      coh.programa_padre_id > 0 &&
      usuario.programas.indexOf(coh.programa_padre_id) < 0
    ) {
      usuario.programas.push(coh.programa_padre_id)
    }

    // Por cada unidad de venta del cohorte
    coh.unidadesventa.forEach((uvkey) => {
      // Verificamos que el usuario tenga la unidad de venta
      if (!usuario.unidadesventa[uvkey]) {
        usuario.unidadesventa[uvkey] = unidadesventa[uvkey]
      }
      let uv = usuario.unidadesventa[uvkey]
      if (!uv) {
        log.error("Unidad de venta inexistente! " + uvkey)
        log.debug(usuario.unidadesventa)
        log.error(uv)
      }
      // Facultades de una UV
      uv.facultades = uv.facultades || {}
      uv.facultades[facultad.key] = uv.facultades[facultad.key] || {}
      uv.facultades[facultad.key][coh.id] = coh
      // Coordinadoras de admisión de una UV
      let coordinadora = coh.usuario_coordinador_admision
      if (
        coordinadora === undefined ||
        coordinadora === "" ||
        coordinadora === null
      ) {
        coordinadora = "Sin asignar"
      }
      uv.coordinadorasadmision = uv.coordinadorasadmision || {}
      uv.coordinadorasadmision[facultad.key] =
        uv.coordinadorasadmision[facultad.key] || {}
      uv.coordinadorasadmision[facultad.key][coordinadora] =
        uv.coordinadorasadmision[facultad.key][coordinadora] || {}
      uv.coordinadorasadmision[facultad.key][coordinadora][coh.id] =
        uv.coordinadorasadmision[facultad.key][coordinadora][coh.id] || {}
      // Calculamos totales cohortes
      uv.totalescohortes = uv.totalescohortes || {}
      uv.totalescohortes[facultad.key] = uv.totalescohortes[facultad.key] || {}
      uv.totalescohortes[facultad.key][coh.año_inicio] =
        uv.totalescohortes[facultad.key][coh.año_inicio] || 0
      uv.totalescohortes[facultad.key][coh.año_inicio]++
      // Calculamos totales borradores
      if (coh.esborrador) {
        uv.totalesborradores = uv.totalesborradores || {}
        uv.totalesborradores[facultad.key] =
          uv.totalesborradores[facultad.key] || {}
        uv.totalesborradores[facultad.key][coh.año_inicio] =
          uv.totalesborradores[facultad.key][coh.año_inicio] || 0
        uv.totalesborradores[facultad.key][coh.año_inicio]++
      }
    })

    return coh
  }

  obtieneUsuarioError(error) {
    log.error("Error cargando usuario")
    log.error(error)
  }

  verificaCohorte(cohorte, facultad) {
    let error = null
    if (cohorte.programaid_anterior === undefined) {
      error = "programaid_anterior indefinido"
    }
    if (
      !cohorte.gradoid ||
      cohorte.gradoid < 1 ||
      (!cohorte.esborrador && (!cohorte.id || cohorte.id < 1)) ||
      (cohorte.esborrador && (!cohorte.maestroid || cohorte.maestroid < 1))
    ) {
      error = "Cohorte sin grado o sin id (o maestroid)"
    }
    if (!facultad || !facultad.key) {
      error = "Cohorte no tiene facultad conocida!"
    }
    if (cohorte.gradoid === undefined) {
      error = "Cohorte sin grado ID"
    }
    if (cohorte.dictado === undefined) {
      error = "cohorte.dictado indefinido"
    }
    if (cohorte.habilitado === undefined) {
      error = "cohorte.habilitado indefinido"
    }
    if (cohorte.unidadVentaForzada === undefined) {
      error = "cohorte.unidadVentaForzada indefinido"
    }
    if (cohorte.fechainicio === undefined) {
      error = "cohorte.fechainicio indefinido"
    }
    if (error !== null) {
      throw new Error(error)
    }
  }

  //TODO: Función para refrescar un atributo para un usuario en todos sus cohortes (ideal si es en uno solo)

  /**
   * Valida si el usuario tiene los datos necesarios para procesar una vista, y de no tenerlos
   * obtiene los atributos faltantes.
   *
   * @param {object|String} vista objeto vista o el nombre corto
   * @param {function} callbackSuccess callback de éxitos
   * @param {function} callbackError callback de error
   * @param {Array} periodos lista de períodos a cargar (null por defecto, cargará período actual)
   * @returns
   */
  validaAtributosVista(vista, callbackSuccess, callbackError, periodos = null) {
    log.debug("Validando atributos para vista")
    log.debug(vista)
    let _fields = null
    if (Array.isArray(vista)) {
      if (vista.length === 0) {
        callbackSuccess()
        return
      }
      _fields = vista.reduce((prev, current) => {
        let _atributo = this.atributos[current]
        if (_atributo && _atributo.esSintetico && _atributo.fieldsRequired) {
          _atributo.fieldsRequired.forEach((f) => {
            if (prev.indexOf(f) < 0) {
              prev.push(f)
            }
          })
        } else {
          prev.push(current)
        }
        return prev
      }, [])
    } else {
      // Obtenemos la vista dependiendo de si el parámetro es el nombre o el objeto
      let view = typeof vista === "object" ? vista : UAI.vistas[vista]
      // Verificamos que tenga datos de atributos
      if (!view.fields && !view.fieldsRequired) {
        callbackSuccess()
        return
      }
      // Usamos fieldsRequired de estar, si no fields (esto evita cargar los atributos sintéticos)
      _fields = view.fieldsRequired ? view.fieldsRequired : view.fields
    }
    if (!_fields) {
      log.debug(vista)
      log.debug(_fields)
      throw new Error("Error creando arreglo de atributos por cargar!")
    }
    // Si no nos indican los períodos para los cuales se obtendrán los datos
    if (!periodos) {
      periodos = [this.periodo]
    }
    log.debug(
      "Validando caché período(s): " +
        periodos.join(",") +
        " para " +
        _fields.length +
        " atributos: " +
        _fields.join(",") +
        "."
    )
    // Calculamos qué atributos nos faltan por cargar
    let missing = []
    periodos.forEach((p) => {
      _fields
        .filter((a) => !this.atributosCargados[p].includes(a))
        .forEach((a) => {
          if (missing.indexOf(a) < 0) {
            missing.push(a)
          }
        })
    })
    // Si hay atributos por cargar
    if (missing.length > 0) {
      log.debug(
        "Faltan " +
          missing.length +
          " atributos por cargar " +
          missing.join(",") +
          " Periodos:" +
          periodos.join(",")
      )
      this.obtieneNuevosAtributosCohortes(
        missing,
        periodos,
        callbackSuccess,
        callbackError
      )
    } else {
      log.debug("Todos los atributos fueron encontrados en el caché.")
      callbackSuccess()
    }
  }

  /**
   * Obtiene un listado de nuevos atributos a cargar
   * @param {Array} atributos listado de atributos a cargar
   * @param {Integer} periodos arreglo de períodos para el cual se cargarán los atributos
   * @param {function} callbackSuccess callback de éxito
   * @param {function} callbackError callback de error
   */
  obtieneNuevosAtributosCohortes(
    atributos,
    periodos,
    callbackSuccess,
    callbackError
  ) {
    let request = []
    periodos.forEach((p) => {
      request.push({
        Usuario: this.username,
        Periodo: p,
        Campos: atributos.concat(UAI.atributosMinimos),
      })
    })
    UAI.servicioPostula(
      UAI.basePostula() + "PostCohorte/ObtenerCohortesPorUsuario",
      "POST",
      request,
      (result) => {
        let _newCohortes = []
        result.forEach((res) => {
          res.Cohortes.filter(
            (c) => c.CohortesSalida && c.CohortesSalida.Respuesta === "OK"
          ).forEach((c) => {
            let _cohorte = c.CohortesSalida
            UAI.agregaIdCohorte(_cohorte, null, "CohorteId", "FacultadId", c)
            if (!_cohorte.id) {
              log.debug(_cohorte)
            }
            if (!this.cohortes[_cohorte.id]) {
              _newCohortes.push(_cohorte)
              log.info(
                "No existía el cohorte " +
                  _cohorte.id +
                  " en objeto usuario. Se agrega a lista de faltantes."
              )
            } else {
              atributos.forEach((a) => {
                this.cohortes[_cohorte.id][a] = c.CohortesSalida[a]
              })
            }
          })
        })
        if (_newCohortes.length > 0) {
          window.alert(
            "Encontramos " +
              _newCohortes.length +
              " cohortes nuevos, para cargarlos debe usar la acción 'Limpiar caché' en el menú de su usuario."
          )
        }
        UAI.agregarAtributosCohortesCache(
          this.username,
          result,
          atributos,
          () => {
            periodos.forEach((p) => {
              this.atributosCargados[p] = this.atributosCargados[p].concat(
                atributos
              )
            })
            log.debug(atributos.length + " atributos cargados en caché.")
            callbackSuccess()
          },
          (err) => {
            log.error("Error guardando en caché")
            callbackError(err)
          }
        )
      },
      callbackError
    )
  }

  /**
   * Procesa respuesta de listado cohortes por usuario de Postula y crea el objeto usuario.
   *
   * @param {*} response respuesta de Postula
   * @param {*} periodo período actual
   */
  obtieneUsuario(response, periodo) {
    let notificaciones = []
    // Verificar que la respuesta de postula es completa
    // TODO: Agregar más condiciones de borde
    if (!Array.isArray(response)) {
      log.error(response)
      log.error("Error grave! No encontramos al usuario en Postula!")
      return null
    }
    // Revisamos que toda respuesta tenga un usuario
    let cleanResponse = []
    response.forEach((res) => {
      if (res && res.Usuario) {
        cleanResponse.push(res)
      }
    })
    if (cleanResponse.length === 0) {
      log.error(response)
      log.error("Error grave! No encontramos al usuario en Postula!")
      return null
    }
    response = cleanResponse
    // Nombre de usuario
    let username = response[0].Usuario
    // Obtiene el arreglo de cohortes desde la respuesta
    let cohortes = []
    let atributosCargados = {}
    response.forEach((res) => {
      cohortes = cohortes.concat(res.Cohortes)
      atributosCargados[res.Periodo] = res.Atributos
    })
    // Arreglo de índices de los cohortes (por cohorte ID)
    let indices = []
    cohortes.forEach((cohorte) => {
      UAI.agregaIdCohorte(cohorte, indices)
    })
    // Arreglos por cargar asíncronicamente (benchmarks)
    let benchmarksPorCargar = []
    let cohortesInvalidos = []
    let cohortesConFechaInicioInvalida = []
    cohortes.forEach((cohorte) => {
      if (!cohorte.CohortesSalida) {
        cohortesInvalidos.push(cohorte.id)
        return
      }
      let benchmarkid = parseInt(cohorte.CohortesSalida.programaid_anterior)
      let añoInicio = new Date(
        Date.parse(cohorte.CohortesSalida.fecha_inicio)
      ).getFullYear()
      if (isNaN(añoInicio) || añoInicio < 2018 || añoInicio > periodo + 1) {
        cohortesConFechaInicioInvalida.push(
          cohorte.id + " " + cohorte.CohortesSalida.nombre
        )
        return
      }
      // Si el cohorte es del período y tiene un cohorte benchmark, se agrega para ser cargado posteriormente
      if (
        benchmarkid > 0 &&
        indices.indexOf(benchmarkid) < 0 &&
        añoInicio >= periodo - 1
      ) {
        // Verificamos que no esté en la lista
        if (benchmarksPorCargar.indexOf(benchmarkid) < 0) {
          benchmarksPorCargar.push(benchmarkid)
        }
      }
    })

    if (cohortesInvalidos.length > 0) {
      log.debug(cohortesInvalidos)
      notificaciones.push({
        mensaje:
          "Encontramos " +
          cohortesInvalidos.length +
          " cohortes inválidos para el usuario",
        objeto: cohortesInvalidos,
      })
    }
    if (cohortesConFechaInicioInvalida.length > 0) {
      log.debug(cohortesConFechaInicioInvalida)
      notificaciones.push({
        mensaje:
          "Encontramos " +
          cohortesConFechaInicioInvalida.length +
          " cohortes con fecha de inicio inválida para el usuario",
        objeto: cohortesConFechaInicioInvalida,
      })
    }
    return {
      username: username,
      cohortes: cohortes,
      atributosCargados: atributosCargados,
      porCargar: benchmarksPorCargar,
      notificaciones: notificaciones,
    }
  }

  obtieneConfiguracionUsuario(_usuario) {
    let esadministrador = false
    let _roles = []
    let usuarioapp = UAI.configuracion.usuarios[_usuario.username]
    // Primero agregar todos los roles que vienen de Postula en cada cohorte
    if (_usuario.cohortes.length > 0) {
      Object.values(_usuario.cohortes).forEach((coh) => {
        if (!coh.Rol) {
          return
        }
        let roles = []
        try {
          roles = JSON.parse(coh.Rol)
        } catch (e) {
          log.warn("Error parseando roles de usuario " + _usuario.username)
          log.warn(e)
          log.warn(coh.Rol)
          log.warn(coh.rol)
          log.warn(coh)
        }
        if (roles.indexOf("Asociado Unidad de Venta") >= 0) {
          roles.push("Director de Ventas")
        }
        for (let idr in roles) {
          let rol = roles[idr]
          if (_roles.indexOf(rol) < 0) {
            _roles.push(rol)
          }
        }
      })
    } else {
      log.warn("Usuario no tiene cohortes para identificar roles!")
    }
    // Segundo, agregar los roles que están definidos en duro en App MP
    if (usuarioapp) {
      for (let idx in usuarioapp.roles) {
        let rol = usuarioapp.roles[idx]
        if (_roles.indexOf(rol.rol) < 0) {
          _roles.push(rol.rol)
        }
      }
    }
    // Ahora se revisa por cada rol que tenga el usuario, las UV y Facultades que debe tener asociadas
    for (let id in _roles) {
      let rol = _roles[id]
      if (rol === "Administrador") {
        esadministrador = true
      }
    }
    _usuario.roles = _roles
    _usuario.esadministrador = esadministrador

    return _usuario
  }
}

export default Usuario
